import AlertRulesTable from './AlertRulesTable';

export default AlertRulesTable;
export { AlertRulesTable };
